import configManagerEmitter from "../utils/configManagerEmitter";

class ConfigManager {
  constructor() {
    if (ConfigManager.instance) {
      return ConfigManager.instance;
    }

    // Default configuration
    this.config = {
      avatarNetworking: { enabled: true },
      UI: { enabled: true },
      VRUI: { enabled: true },
      voiceChat: { enabled: true },
      textChat: { enabled: true },
      spawnAndMoveMedia: { enabled: true },
      invisibleAvatar: { enabled: false },
      roomEntryDialog: {
        exitButton: { enabled: true },
        roomName: { enabled: true },
        joinMetaverse: { enabled: true },
        enterOnAR: { enabled: false },
        enterOnVR: { enabled: true },
        lookAround: { enabled: true },
        roomSettings: { enabled: true },
        poweredBy: { enabled: false, label: "Powered By" }
      },
      spawnCamera: { enabled: true },
      spawnEmoji: { enabled: true },
      directEnterAR: { enabled: false },
      shortcuts: { enabled: true },
      idle: { enabled: true },
      loadingScreen: {
        showLogo: true,
        showLoadingText: true,
        showHint: true,
        useSceneBackground: false,
        customLoadingColor: null
      },
      canInspectObjects: { enabled: true },
      joystick: { enabled: true },
      cursorVisible: { enabled: true },
      previewRotation: { enabled: true },
      showButtonInfo: { enabled: true },
      avatarDialog: {
        enabled: true,
        showName: true,
        showPreview: true,
        changeAvatar: true
      },
      participantLayout: {
        enabled: true,
        defaultEnabled: false,
        forceEnabled: false
      },
      deviceDialog: {
        enabled: true,
        showSpeaker: true
      },
      toolbar: {
        socialButton: { enabled: true },
        moreButton: { enabled: true }
      },
      notifications: {
        enabled: true,
        position: "top"
      },
      assetUploadCapacity: 50
    };
    this.defaultConfig = this.deepMerge({}, this.config);

    ConfigManager.instance = this;
    window.ConfigManager = this;
    this.synced = false;
    this.initialize();
  }

  initialize() {
    configManagerEmitter.emit("configUpdated", this.config);
  }

  addConfig(newConfig) {
    this.config = this.deepMerge(this.config, newConfig);
    this.synced = true;
    configManagerEmitter.emit("configUpdated", this.config);
  }

  reset() {
    this.config = this.deepMerge({}, this.defaultConfig);
    this.synced = false;
    configManagerEmitter.emit("configUpdated", this.config);
  }

  deepMerge(target, source) {
    const output = Object.assign({}, target);
    if (this.isObject(target) && this.isObject(source)) {
      Object.keys(source).forEach(key => {
        if (this.isObject(source[key])) {
          if (!(key in target)) Object.assign(output, { [key]: source[key] });
          else output[key] = this.deepMerge(target[key], source[key]);
        } else {
          Object.assign(output, { [key]: source[key] });
        }
      });
    }
    return output;
  }

  isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
  }

  getConfig() {
    return this.config;
  }
}

const configManager = new ConfigManager();
// Object.freeze(configManager); // Freeze to prevent modifications

export default configManager;
